module.exports = __webpack_public_path__ + "static/media/cisco_logo.814498b8.png";